import React from "react";

export default () => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.0100098 11.47H22.05L11.31 0.71L12.01 0L24 12L12.01 24L11.31 23.29L22.12 12.47H0.0100098V11.47Z"
      fill="currentColor"
    />
  </svg>
);
